import classNames from 'classnames'
import Button from 'components/shared/Button/Button'
import Icon from 'components/shared/Icon/Icon'
import PropTypes from 'prop-types'
import { withNamespaces } from 'react-i18next'

import greyDashedRing from '../../../images/icons/grey-dashed-ring.svg'
import './PathwayProjectCard.scss'

export const PathwayProjectCard = ({
  badgeAvailable,
  badgeImage,
  className,
  locale,
  project: {
    content: { title, description, heroImage },
    repositoryName,
  },
  state,
  t,
  tags,
  ordered,
}) => {
  const iconClass = classNames('sc-pr-pathway-project__summary-icon', {
    'sc-pr-pathway-project__summary-icon--in_progress': state === 'inProgress',
    'sc-pr-pathway-project__summary-icon--complete': state === 'complete',
    'sc-pr-pathway-project__summary-icon--not-started': !(
      state === 'inProgress' || state === 'complete'
    ),
  })

  let iconType = 'unchecked'
  let buttonText = t('pathway.button.start-project')
  if (state === 'inProgress') {
    iconType = 'sync'
    buttonText = t('pathway.button.continue-project')
  } else if (state === 'complete') {
    iconType = 'tick'
    buttonText = t('pathway.button.revisit-project')
  }

  const BadgeStatus = ({ badgeImage: image }) => {
    return (
      <span className={'sc-pr-pathway-project__badge-status'}>
        {image ? (
          <>
            <img
              className={'sc-pr-pathway-project__badge-status-icon'}
              src={image}
              alt={''}
            />
            {t('pathway.badge.issued')}
          </>
        ) : (
          <>
            <img src={greyDashedRing} alt={''} />
            {t('pathway.badge.not-issued')}
          </>
        )}
      </span>
    )
  }

  return (
    <div
      className={classNames(
        'sc-pr-pathway-project rpf-shadow-centre',
        className
      )}
    >
      <div className={'sc-pr-pathway-project__summary'}>
        <span className={iconClass}>
          <Icon type={iconType} />
        </span>
        <div className="sc-pr-pathway-project__summary-title">{title}</div>
      </div>
      <div
        className={classNames('sc-pr-pathway-project__details-inner', {
          'sc-pr-pathway-project__details-inner--ordered': !!ordered,
        })}
      >
        <img
          alt=""
          className={'sc-pr-pathway-project____image'}
          src={heroImage}
        />

        <div className="sc-pr-pathway-project__description">
          <p>{description}</p>
          {Boolean(tags && tags.length) && (
            <ul className={'sc-pr-pathway-project__tags'}>
              {tags.map((tag, i) => {
                return (
                  <li key={i} className={'sc-pr-tag'}>
                    {tag}
                  </li>
                )
              })}
            </ul>
          )}
          {badgeAvailable && <BadgeStatus badgeImage={badgeImage} />}
          <Button
            type="primary"
            className={'sc-pr-pathway-project__button'}
            text={buttonText}
            href={`/${locale}/projects/${repositoryName}`}
          />
        </div>
      </div>
    </div>
  )
}

PathwayProjectCard.propTypes = {
  badgeAvailable: PropTypes.bool,
  badgeImage: PropTypes.string,
  className: PropTypes.string,
  locale: PropTypes.string.isRequired,
  project: PropTypes.object.isRequired,
  state: PropTypes.string,
  tags: PropTypes.arrayOf(PropTypes.string),
  t: PropTypes.func.isRequired,
}

export default withNamespaces('translations')(PathwayProjectCard)
